import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';

const mutation = gql`
mutation Users($id: Int, $user: UpdateUserInput!, $avatar: Upload) {
  updateUser(id: $id, user: $user, avatar: $avatar) {
  user {
    id
    role
    operatorTeamId
    overseerTeams {
      id,
      name
    }
    name
    email
    fullName
    firstName
    lastName
    middleName
    displayName
    absenceReason
    avgVote
    logged
    ready
    ucceInfo {
      uccePeripheralId
      uccePeripheralFirstName
      uccePeripheralLastName
      uccePeripheralLogin
    }
    useExpress
    ctsUserId
    ldapUser
    ldapStatus
    external
    }
    avatarUpload
  }
}`;

const fieldsName = {
  name: 'T_LOGIN',
  email: 'T_EMAIL',
  role: 'T_ROLE',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function updateUser({
  id,
  name,
  email,
  firstName,
  lastName,
  middleName,
  displayName,
  role,
  operatorTeamId,
  overseerTeamsIds,
  uccePeripheralId,
  uccePeripheralFirstName,
  uccePeripheralLastName,
  uccePeripheralLogin,
  useExpress,
  ctsUserId,
  avatar,
  currentAvatarId,
  external,
  sipUrl,
  sipPassword,
}) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id: parseInt(id, 10),
      user: {
        name,
        email,
        firstName,
        lastName,
        middleName,
        displayName,
        role,
        operatorTeamId,
        overseerTeamsIds,
        uccePeripheralId,
        uccePeripheralFirstName,
        uccePeripheralLastName,
        uccePeripheralLogin,
        useExpress,
        ctsUserId,
        currentAvatarId,
        external,
        sipUrl,
        sipPassword,
      },
      avatar,
    },
  }).then((res) => res.data.updateUser)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default updateUser;
